module.exports = function () {
  var help = 'Pirate Attacks';
  var html = "\n      <div class=\"piracy-overlay\" id=\"piracy-overlay\">\n\t<div class=\"help\">".concat(help, "</div>\n\t<div class=\"piracy-grid\">\n\t  <div class=\"attacker\">\n\t    <div class=\"title\">anti-piracy coalition</div>\n\t  </div>\n\t  <div class=\"defender\">\n\t    <div class=\"title\">surviving pirate forces</div>\n\t  </div>\n\t</div>\n\t</div>\n      </div>\n  ");
  return html;
};